import React, { useState, useEffect, useRef } from 'react';
import { useSetRecoilState } from 'recoil';
import { overlayProppress } from '../../atoms/OverlayProgress';
import { flashMessageSuccess, flashMessageError } from '../../atoms/FlashMessage';
import { RouteComponentProps } from 'react-router-dom';
import * as _form from '../../helper/form';
import * as _rolesFormFunc from './func/RolesForm'
import Paper from '@material-ui/core/Paper';
import Loading from '../../components/View/Loading';
import HeadButtonGroups, { HeadButtonGroupBtnActionsProps } from '../../components/View/HeadButtonGroups';
import axios from 'axios';
import RoleActionInputs from './RoleActionInputs';
import ZshTextField from '../../components/Form/ZshTextField';

type roleNamesProps = {
  title: string;
  actions: any;
}

type roleFormDataProps = {
  name: string;
  role: { [key: string]: string[] };
}

function RolesAdd({ history }: RouteComponentProps) {

  const setOverlayProppress = useSetRecoilState(overlayProppress);
  const setFlashMessageSuccess = useSetRecoilState(flashMessageSuccess);
  const setFlashMessageError = useSetRecoilState(flashMessageError);

  const actionName = 'roles/add/';
  const backActionName = '/roles';

  const unmounted = useRef(false);
  const source = useRef(axios.CancelToken.source());

  const [isInit, setInit] = useState(true);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState<roleFormDataProps>({
    name: '',
    role: {}
  });
  const [validateErrors, setValidateErrors] = useState({});
  const [roleNames, setRoleNames] = useState<{ [key: string]: roleNamesProps }>({});
  const [roleNamesError, setRoleNamesError] = useState(false);
  const [loadings, setLoadings] = useState({
    roleNames: true
  });

  const handleChange = (event: any) => {
    const inputName = event.target.name;
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
    setFormData({ ...formData, [inputName]: value });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    _form.handleSubmit({
      action: actionName,
      formData,
      history,
      backActionName,
      setOverlayProppress,
      setFlashMessageSuccess,
      setFlashMessageError,
      setValidateErrors
    });
  }

  const handleChangeRoleAction = (event?: React.ChangeEvent<HTMLInputElement>, checked?: boolean, roleKey?: string) => {
    let role: { [key: string]: string[] } = _rolesFormFunc.handleChangeRoleAction({
      event,
      checked,
      roleKey,
      formData
    });
    setFormData({ ...formData, role });
  }

  // clean up
  useEffect(() => {
    const clSource = Object.assign({}, source.current);
    return () => {
      // cancel axios get
      clSource.cancel('cancel roles names get');
      unmounted.current = true;
    }
  }, []);

  useEffect(() => {
    if (isInit) {
      const initFunc = async () => {
        await _rolesFormFunc.getRoleNames({
          unmounted: unmounted.current,
          setRoleNames,
          setLoadings,
          setRoleNamesError,
          source
        });
        await ((): any => {
          setLoading(false);
          return Promise.resolve(1);
        })();
      }
      initFunc();
      setInit(false);
    }
  }, [isInit]);

  const btnActions: HeadButtonGroupBtnActionsProps[] = [
    {
      type: 'save',
    }
  ];

  return (
    <div className="content-1">
      <form onSubmit={handleSubmit}>
        <Loading loading={loading} />
        {
          loading === false &&
          <div>
            <HeadButtonGroups
              history={history}
              btnActions={btnActions}
            />
            <Paper>
              <div className="view-content-in form-content">
                {
                  loadings.roleNames === false &&
                  roleNamesError === false &&
                  <div>
                    <table className="form-table">
                      <tbody>
                        <tr>
                          <th className="required-th">権限グループ名</th>
                          <td>
                            <div className="form-input-group">
                              <ZshTextField
                                value={formData.name}
                                name="name"
                                onChange={handleChange}
                                required
                                fullWidth
                                validateErrors={validateErrors}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>権限設定</th>
                          <td>
                            <div>
                              {
                                Object.keys(roleNames).length > 0 &&
                                Object.keys(roleNames).map((roleKey: string) => (
                                  <div key={roleKey}>
                                    <p className="role-key-name">{roleNames[roleKey].title}</p>
                                    <RoleActionInputs
                                      roleKey={roleKey}
                                      actions={roleNames[roleKey].actions}
                                      formDataRole={formData.role}
                                      handleChangeRoleAction={handleChangeRoleAction}
                                    />
                                  </div>
                                ))
                              }
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                }
                {
                  loadings.roleNames === false &&
                  roleNamesError === true &&
                  <div>
                    データを取得できませんでした。<br />ページリロードをお願いします。
                </div>
                }
              </div>
            </Paper>
            <HeadButtonGroups
              history={history}
              btnActions={btnActions}
            />
          </div>
        }
      </form>
    </div>
  )
}

export default RolesAdd;